module.exports = __webpack_public_path__ + "static/media/tweet-twitter-twitter-icon-svgrepo-com.34d28cd1.svg";